import { useState } from "react";

export const useBoolean = (
  initValue?: boolean,
): [boolean, () => void, () => void] => {
  const [state, setState] = useState(!!initValue);
  return [state, () => setState(true), () => setState(false)];
};
